<template>
  <div>
    <ul>
      <li
        v-for="{ name, inputs } in $options.fields"
        :key="`setting-field-${name}`"
        class="account-field"
      >
        <div class="account-field-name">{{ $t(`account.settings.fields.${name}`) }}</div>
        <div>
          <!-- hide editable inputs, show fields data -->
          <div v-if="!editableFields[name]" class="flex items-center">
            <span class="mr-2" :class="[name === 'password' && 'text-3xl']">
              {{ labelField(userFields, name) }}
            </span>
            <span
              v-if="(name !== 'email' && isAdmin) || !isAdmin"
              @click="editableFields[name] = !editableFields[name]"
              class="account-field-edit"
            >
              {{
                name === 'password'
                  ? $t('account.settings.btns.password')
                  : $t('account.settings.btns.edit')
              }}
            </span>
          </div>
          <!-- show editable inputs -->
          <div v-else class="flex items-center w-full">
            <div v-for="input in inputs" :key="`setting-input-${input.model}`" class="mr-2">
              <input
                v-model="userFields[input.model]"
                :placeholder="input.label"
                class="account-field-input"
              />
            </div>
            <span @click="save" class="account-field-save">
              {{ $t('account.settings.btns.save') }}
            </span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Settings',
  data() {
    return {
      userFields: {
        firstName: this.user.firstName || '',
        lastName: this.user.lastName || '',
        email: this.user.email || '',
        password: '',
      },
      editableFields: {
        name: false,
        email: false,
        password: false,
      },
    };
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    labelField(data, name) {
      return name === 'name'
        ? `${data['firstName']} ${data['lastName']}`
        : name === 'password'
        ? '·········'
        : data[name];
    },
    reset() {
      this.editableFields = { name: false, email: false, password: false };
    },
    save() {
      this.$emit('save', this.userFields);
      this.reset();
    },
  },
  fields: [],
  created() {
    // non reactive data use to generate fields
    this.$options.fields = [
      {
        name: 'name',
        inputs: [
          { model: 'firstName', label: 'First Name' },
          { model: 'lastName', label: 'Last Name' },
        ],
      },
      {
        name: 'email',
        inputs: [{ model: 'email', label: 'Email' }],
      },
      {
        name: 'password',
        inputs: [{ model: 'password', label: 'Password' }],
      },
    ];
  },
};
</script>
